import React from 'react';
import { Link } from 'react-router-dom';
import './AuthHeader.css';
import Logo from '../../Assest/sumber-lancar.png';
const AuthHeader = () => {
  return (
    <header className="auth-header">
      <div className="auth-header-container">
        <Link to="/" className="navbar-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={Logo} alt=''/>
          <div className="logo-text">
            <span>Sumber</span>
            <span>Lancar</span>
          </div>
        </Link>

      </div>
    </header>
  );
};

export default AuthHeader;